import React, { useEffect } from 'react';
import { bool, func, shape, string } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';

import { fetchSystemTypes } from '../../../actions/systemTypeActions';
import { fetchSystemTypesLookup } from '../../../actions/lookupActions';
import MultiSensorSelect from './MultiSensorSelect';
import Select from '../../../components/FormFields/Select';
import SensorTypeSelect from './SensorTypeSelect';

import defaultClasses from './ModifyRuleSensorModal.module.css';

const SystemSourceFieldset = ({
    errors,
    fetchSystemTypesLookup,
    hidden,
    onBlur,
    onChange,
    onPatch,
    ruleTarget,
    touched,
    values
}) => {
    const dispatch = useDispatch();
    const systemTypes = useSelector(
        ({ systemTypes }) => systemTypes
    );

    useEffect(() => {
        if (systemTypes.loading || systemTypes.data.length) {
            return;
        }
        dispatch(fetchSystemTypesLookup());
    }, []);

    function handleChange(event) {
        const { value } = event.target;
        const systemType = systemTypes.data.find(
            ({ id }) => id === value
        );
        onPatch({
            systemTypeId:   value,
            systemTypeName: systemType.name
        });
    }

    if (hidden) {
        return null;
    }

    return (
        <FormControl
            aria-labelledby="system-sensor-label"
            className={defaultClasses.fieldset}
            role="group"
        >
            <FormLabel
                className={defaultClasses.legend}
                id="system-sensor-label"
                focused={false}
            >
                System Sensor Options
            </FormLabel>
            <Select
                error={systemTypes.error}
                errors={errors.systemTypeId}
                isLoading={systemTypes.loading}
                label="System Type"
                name="systemTypeId"
                onBlur={onBlur}
                onChange={handleChange}
                required
                touched={touched.systemTypeId}
                value={values.systemTypeId}
            >
                {(systemTypes.data || []).map(({ id, name }) => (
                    <MenuItem key={id} value={id}>{name}</MenuItem>
                ))}
            </Select>
            <SensorTypeSelect
                errors={errors}
                onBlur={onBlur}
                onPatch={onPatch}
                touched={touched}
                values={values}
            />
            <MultiSensorSelect
                errors={errors}
                onBlur={onBlur}
                onChange={onChange}
                ruleTarget={ruleTarget}
                touched={touched}
                values={values}
            />
        </FormControl>
    );
};

SystemSourceFieldset.propTypes = {
    fetchSystemTypes,
    fetchSystemTypesLookup,
    hidden:   false,
    onBlur:   () => {},
    onChange: () => {},
    onPatch:  () => {}
};

SystemSourceFieldset.propTypes = {
    errors: shape({
        systemTypeId: string
    }),
    fetchSystemTypes:       func,
    fetchSystemTypesLookup: func,
    hidden:                 bool,
    onBlur:                 func,
    onChange:               func,
    onPatch:                func,
    ruleTarget:             string,
    touched:                shape({
        systemTypeId: bool
    }),
    values: shape({
        systemTypeId: string
    })
};

export default SystemSourceFieldset;
